import React from 'react';
import { DataContext } from '../DataProvider';

import useWindowDimensions from '../../hooks/use-window-dimensions.hook';

function Reminder({ idx }) {
  const {
    remindersList,
    deleteReminder,
    setReminderBeingEdited,
    setReminderDialogOpen,
  } = React.useContext(DataContext);

  const { width } = useWindowDimensions();
  const isNarrow = width < 600;

  const reminder = remindersList[idx];

  const handleDelete = (itemToDelete) => {
    deleteReminder(itemToDelete.KEY, false);
  };

  const handleInitiateEdit = () => {
    console.log('initiating edit');
    setReminderBeingEdited(reminder);
    setReminderDialogOpen(true);
  };

  function isMobileOrNarrowScreen() {
    const userAgentIsMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
    return userAgentIsMobile || isNarrow;
  }

  function formatAdaptiveDate(originalStr) {
    const match = originalStr.match(
      /^(\d{2})-(\d{2})-(\d{4})-(\d{1,2}:\d{2})(AM|PM)$/
    );
    if (!match) return originalStr;

    const [, mmStr, ddStr, yyyyStr, timePart, ampm] = match;
    const month = parseInt(mmStr, 10);
    const day = parseInt(ddStr, 10);
    const year = parseInt(yyyyStr, 10);
    const monthAbbr = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    let [hrStr, minuteStr] = timePart.split(':');
    let hour = parseInt(hrStr, 10);
    if (ampm === 'PM' && hour < 12) hour += 12;
    if (ampm === 'AM' && hour === 12) hour = 0;

    const dateObj = new Date(
      year,
      month - 1,
      day,
      hour,
      parseInt(minuteStr, 10)
    );
    const currentYear = new Date().getFullYear();
    const shortYear = String(year).slice(-2);
    const fullYear = String(year);
    const abbr = monthAbbr[month - 1] || mmStr;

    const localHour = dateObj.getHours();
    const localMinute = dateObj.getMinutes().toString().padStart(2, '0');
    const meridiem = localHour >= 12 ? 'PM' : 'AM';
    const hour12 = localHour % 12 || 12;

    const isOnTheHour = localMinute === '00';
    const timeStr = isOnTheHour
      ? `${hour12}${meridiem}`
      : `${hour12}:${localMinute}${meridiem}`;

    if (year === currentYear) {
      return `${abbr} ${day}, ${timeStr}`;
    } else {
      return `${abbr} ${day}, ${fullYear}`;
    }
  }
  // ... existing code ...

  // Convert “MM-DD-YYYY-hh:mmAM/PM” to more compact or full format
  const displayDate = formatAdaptiveDate(reminder.datetime);

  return (
    <>
      <tr>
        <td class='col-controls'>
          <button onClick={() => handleDelete(reminder)}>{trashcanIcon}</button>
          {/* <button onClick={() => handleInitiateEdit()}>{editIcon}</button> */}
        </td>
        <td class='col-date'>{displayDate}</td>
        <td class='col-text'>
          <span class='reminder-text' onClick={() => handleInitiateEdit()}>
            {reminder.reminder}
          </span>
        </td>
      </tr>
    </>
  );
}

export default Reminder;

const trashcanIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='1'
    strokeLinecap='round'
    strokeLinejoin='round'
    className='lucide lucide-trash-2'
  >
    <path d='M3 6h18' />
    <path d='M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6' />
    <path d='M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2' />
    <line x1='10' x2='10' y1='11' y2='17' />
    <line x1='14' x2='14' y1='11' y2='17' />
  </svg>
);

const editIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='1'
    strokeLinecap='round'
    strokeLinejoin='round'
    className='lucide lucide-square-pen-icon lucide-square-pen'
  >
    <path d='M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7' />
    <path d='M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z' />
  </svg>
);
